import getScrollPosition from '../media/getScrollPosition';

export default function getElementTop(el) {
  if(typeof(el) === 'string') el = document.querySelector(el);
  return el ? el.getBoundingClientRect().top + getScrollPosition() : 0;
}
